export function forLoggedInUser(payload: { uid: string }): string {
  return payload.uid;
}

export function forConsole(
  payload: { uid: string } | { consoleId: string }
): string {
  return 'consoleId' in payload ? payload.consoleId : payload.uid;
}

export function forOrganisation(payload: { organisationId: string }): string {
  return `organisations/${payload.organisationId}`;
}

export function forConversation(payload: { conversationId: string }): string {
  return payload.conversationId;
}

export function forWholeSystem(): string {
  return 'system';
}

export function forAllHil(): string {
  return 'jobs';
}

export function forRecordingsModule(): string {
  return 'recordings';
}

export function forAllConsoles(): string {
  return 'console/all';
}
